(function () {
  // automatically click the radio button when page rendered
  window.onload = function() {
    document.getElementById('auto-clicked').click();
  };

  function moneyText(el) {
    if (!el) return "";
    return (el.textContent || "").trim();
  }

  // ---------- Groups (Purchase Options) ----------
  function getGroupsContainer(wrapper) {
    return wrapper.querySelector(".bsub-widget__groups-container");
  }

  function getSubscribeGroupAndId(groupsContainer) {
    const subscribeGroup = groupsContainer.querySelector(
      ".bsub-widget__group[data-bsub-selling-plan-group-id]"
    );
    const groupId = subscribeGroup?.getAttribute("data-bsub-selling-plan-group-id") || "";
    return { subscribeGroup, groupId };
  }

  function getOneTimeGroup(groupsContainer) {
    return (
      groupsContainer
        .querySelector('input[name="bsub-selling-plan-group"][value="once"]')
        ?.closest(".bsub-widget__group") || null
    );
  }

  // ---------- Variant price resolver (follows selected variant) ----------
  let __bsubVariantPriceMap = null;
  let __bsubVariantMapLoading = false;

  function getProductHandleFromURL() {
    const m = window.location.pathname.match(/\/products\/([^\/\?]+)/);
    return m ? m[1] : null;
  }

  async function ensureVariantPriceMap() {
    if (__bsubVariantPriceMap || __bsubVariantMapLoading) return;
    const handle = getProductHandleFromURL();
    if (!handle) return;

    __bsubVariantMapLoading = true;
    try {
      const res = await fetch(`/products/${handle}.js`);
      const data = await res.json();
      __bsubVariantPriceMap = new Map();
      (data.variants || []).forEach((v) => {
        __bsubVariantPriceMap.set(String(v.id), v.price); // cents
      });
    } catch (e) {
      __bsubVariantPriceMap = null;
    } finally {
      __bsubVariantMapLoading = false;
    }
  }

  function getProductForm() {
    const wrapper = document.querySelector(".bsub-widget__wrapper");
    return (
      wrapper?.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function getCurrentVariantId() {
    const urlVid = new URLSearchParams(window.location.search).get("variant");
    if (urlVid) return String(urlVid);

    const form = getProductForm();
    const idInput = form?.querySelector('input[name="id"]');

    if (!idInput) return "";
    return String(idInput.value || idInput.getAttribute("value") || "");
  }

  function formatMoneyFromCents(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return "";

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      const fmt = window.Shopify.money_format || "${{amount}}";
      return window.Shopify.formatMoney(n, fmt);
    }
    return `$${(n / 100).toFixed(2)}`;
  }

  async function getRetailPriceFromCurrentVariant() {
    await ensureVariantPriceMap();
    const vid = getCurrentVariantId();
    if (!vid || !__bsubVariantPriceMap) return "";
    const cents = __bsubVariantPriceMap.get(vid);
    if (cents == null) return "";
    return formatMoneyFromCents(cents);
  }

  async function getRetailPrice() {
    const v = await getRetailPriceFromCurrentVariant();
    if (v) return v;

    const s = document.querySelector("#bsub-retail-price");
    const txt = (s && s.textContent ? s.textContent : "").trim();
    return txt || "";
  }

  // ---------- Selling plan container resolver (supports BOTH DOM types) ----------
  function getPlanContext(wrapper, groupId) {
    // A) New site (your HTML): plans-container
    const plansContainer = wrapper.querySelector(
      `.bsub-widget__plans-container[data-bsub-selling-plan-group-id="${groupId}"]`
    );
    if (plansContainer) {
      const planInputs = Array.from(
        plansContainer.querySelectorAll('input[type="radio"][data-bsub-selling-plan-input]')
      );
      return {
        type: "plans",
        container: plansContainer,
        inputs: planInputs,
        getCheckedInput: () =>
          plansContainer.querySelector('input[type="radio"][data-bsub-selling-plan-input]:checked'),
        getTextForInput: (inp) => {
          const header = inp.closest("label")?.querySelector(".bsub-widget__plan-header");
          return (
            header?.querySelector(".bsub-widget__text")?.textContent?.trim() ||
            inp.value ||
            ""
          );
        },
        getPriceForInput: (inp) => {
          const header = inp.closest("label")?.querySelector(".bsub-widget__plan-header");
          const priceEl = header?.querySelector('[data-bsub-per-delivery-price]');
          return moneyText(priceEl);
        },
      };
    }

    // B) Old site: options-container
    const optionsContainer = wrapper.querySelector(
      `.bsub-options-container[data-bsub-selling-plan-group-id="${groupId}"]`
    );
    if (optionsContainer) {
      const planInputs = Array.from(
        optionsContainer.querySelectorAll('input[type="radio"][data-bsub-delivery-frequency-option]')
      );
      return {
        type: "options",
        container: optionsContainer,
        inputs: planInputs,
        getCheckedInput: () =>
          optionsContainer.querySelector(
            'input[type="radio"][data-bsub-delivery-frequency-option]:checked'
          ),
        getTextForInput: (inp) => {
          const header = inp.closest("label")?.querySelector(".bsub-widget__plan-header");
          const main =
            header?.querySelector(".bsub-widget__main-text")?.textContent?.trim() || "";
          return main || inp.value || "";
        },
        getPriceForInput: (inp) => {
          const header = inp.closest("label")?.querySelector(".bsub-widget__plan-header");
          const priceEl = header?.querySelector('[data-bsub-per-delivery-price]');
          return moneyText(priceEl);
        },
      };
    }

    return null;
  }

  function buildCustomUI(wrapper) {
    if (wrapper.querySelector(".bsub-custom-ui")) return true;

    const groupsContainer = getGroupsContainer(wrapper);
    if (!groupsContainer) return false;

    const { subscribeGroup: subscribe, groupId } = getSubscribeGroupAndId(groupsContainer);
    const onetime = getOneTimeGroup(groupsContainer);
    if (!subscribe || !onetime || !groupId) return false;

    const subscribeInput = subscribe.querySelector("input[type='radio']");
    const onetimeInput = onetime.querySelector("input[type='radio']");
    if (!subscribeInput || !onetimeInput) return false;

    const ctx = getPlanContext(wrapper, groupId);
    if (!ctx || !ctx.inputs.length) return false;

    // Hide native UI (keep for Bold logic)
    groupsContainer.style.display = "none";
    ctx.container.style.display = "none";

    // Custom UI root
    const ui = document.createElement("div");
    ui.className = "bsub-custom-ui";

    const subCard = document.createElement("div");
    subCard.className = "bsub-card bsub-card-subscribe";
      // <div class="bsub-card-price" data-role="sub-price">
      //   <span class="bsub-sub-price-text" data-role="sub-price-text"></span>
      //   <span class="bsub-compare-price" data-role="sub-compare" style="display:none;"></span>
      // </div>
    subCard.innerHTML = `
      <div class="bsub-card-head">
        <div style = "display:flex; flex:9">
          <div class="bsub-radio-dot" data-role="sub-dot" id = "auto-clicked"></div>
          <div style = "padding-left:10px">
          <div class="bsub-card-title" style="color:#111;">Auto-Ship Subscription</div>
          <div class="bsub-card-subtitle">Easy Repeat Deliveries - Enjoy Bigger Savings</div>
          </div>
        </div>
        <div class = "bsub-card-price" style = "flex:2">
          <span class="bsub-sub-price-text" data-role="sub-price-text"></span>
          <span class="bsub-compare-price" data-role="sub-compare" style="display:none;"></span>
        </div>
      </div>

      <div class="bsub-sub-box">
        <div class="bsub-benefits">

            <div class="bsub-benefit">
              <span class="bsub-icon">💰</span>
              <span>Keep saving on every order</span>
            </div>

            <div class="bsub-benefit">
              <span class="bsub-icon">📅</span>
              <span>Get deliveries on your schedule</span>
            </div>

            <div class="bsub-benefit">
              <span class="bsub-icon">✏️</span>
              <span>Skip, change, or cancel anytime</span>
            </div>

      </div>

      </div>

      <div class="bsub-get-every" style = "color: gray">Get it</div>
      <div class="bsub-tiles-row" data-role="tiles"></div>
    `;

    // One-time Card
    const oneCard = document.createElement("div");
    oneCard.className = "bsub-card bsub-card-onetime";
    oneCard.innerHTML = `
      
      <div class="bsub-card-head">
        <div style = "display:flex; flex:9">
          <div class="bsub-radio-dot"></div>
          <div class="bsub-card-title" style="color:#111; padding-left:10px">One-time purchase</div>
        </div>
        <div class="bsub-card-price" stlye = "font-weight:bold; flex:2" data-role="one-price"></div>
      </div>
    `;

    ui.appendChild(subCard);
    ui.appendChild(oneCard);
    wrapper.insertBefore(ui, wrapper.firstChild);

    // Move collapsible details under subscribe (if exists on this theme)
    const collapsible = wrapper.querySelector(".bsub__collapsible-wrapper");
    if (collapsible) subCard.insertAdjacentElement("afterend", collapsible);

    // Build tiles
    const tilesHost = subCard.querySelector('[data-role="tiles"]');
    ctx.inputs.forEach((inp) => {
      const fullText = ctx.getTextForInput(inp);
      const lower = String(fullText).toLowerCase();
      // const isRec = lower.includes("most popular") || lower.includes("recommended");

      const tile = document.createElement("div");
      tile.className = "bsub-tile";
      tile.dataset.for = String(inp.value || "");

      tile.innerHTML = `
      <div class="main">${fullText}</div>
      `;

      tile.addEventListener("click", () => {
        subscribeInput.click();
        inp.click();
        syncStateBurst();
      });

      tilesHost.appendChild(tile);
    });

    // Click handlers
    subCard.addEventListener("click", (e) => {
      if (e.target.closest(".bsub-tile") || e.target.closest('[data-role="how"]')) return;
      subscribeInput.click();
      syncStateBurst();
    });

    oneCard.addEventListener("click", () => {
      onetimeInput.click();
      syncStateBurst();
    });

    const how = subCard.querySelector('[data-role="how"]');
    if (how) {
      how.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const btn = wrapper.querySelector(".bsub-widget__toggle-details-btn");
        if (btn) btn.click();
      });
    }

    async function syncState() {
      // selection style
      if (subscribeInput.checked) {
        subCard.classList.add("selected");
        oneCard.classList.remove("selected");
      } else {
        subCard.classList.remove("selected");
        oneCard.classList.add("selected");
      }

      // prices
      const checkedPlan = ctx.getCheckedInput();
      const subPrice = checkedPlan ? ctx.getPriceForInput(checkedPlan) : "";
      const retail = await getRetailPrice();

      // main subscribe price (red via css)
      subCard.querySelector('[data-role="sub-price-text"]').textContent = subPrice || "";

      // compare (strike one-time) after subscribe price
      const compareEl = subCard.querySelector('[data-role="sub-compare"]');
      if (subPrice && retail) {
        compareEl.textContent = retail;
        compareEl.style.display = "inline";
      } else {
        compareEl.textContent = "";
        compareEl.style.display = "none";
      }

      // one-time card price
      oneCard.querySelector('[data-role="one-price"]').textContent = retail || "";

      // tile selected state
      const checkedValue = checkedPlan ? String(checkedPlan.value || "") : "";
      const tiles = Array.from(wrapper.querySelectorAll(".bsub-custom-ui .bsub-tile"));
      tiles.forEach((t) => t.classList.remove("selected"));
      if (checkedValue) {
        const match = tiles.find((t) => t.dataset.for === checkedValue);
        if (match) match.classList.add("selected");
      }
    }

    // Burst sync: reduce “click delay” perception (run multiple times as Bold finishes updating)
    function syncStateBurst() {
      syncState();
      setTimeout(syncState, 0);
      setTimeout(syncState, 60);
      setTimeout(syncState, 180);
    }

    // Warm cache
    ensureVariantPriceMap();

    // Initial sync: make sure it shows immediately on load
    (function initialSyncLoop() {
      let tries = 0;
      const tick = () => {
        tries += 1;
        syncState();
        // stop when we have sub price or after some retries
        const hasSub = !!subCard.querySelector('[data-role="sub-price-text"]')?.textContent?.trim();
        if (hasSub || tries > 12) return;
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    })();

    // Listen radios change (selling plan group / selling plan)
    wrapper.addEventListener("change", (e) => {
      if (e.target && e.target.matches('input[type="radio"]')) {
        syncStateBurst();
      }
    });

    // Watch variant id changes (update one-time + compare)
    (function watchVariantIdChange() {
      const form = getProductForm();
      const idInput = form?.querySelector('input[name="id"]');

      if (!idInput) return;

      let last = String(idInput.value || "");

      const mo = new MutationObserver(() => {
        const now = String(idInput.value || idInput.getAttribute("value") || "");
        if (now && now !== last) {
          last = now;
          syncStateBurst();
        }
      });
      mo.observe(idInput, { attributes: true, attributeFilter: ["value"] });

      setInterval(() => {
        const now = String(idInput.value || "");
        if (now && now !== last) {
          last = now;
          syncStateBurst();
        }
      }, 250);

      document.addEventListener("variant:change", syncStateBurst);
      document.addEventListener("product:variant-change", syncStateBurst);
    })();

    return true;
  }

  function init() {
    const wrapper = document.querySelector(".bsub-widget__wrapper");
    if (!wrapper) return false;
    return buildCustomUI(wrapper);
  }

  if (init()) return;

  const mo = new MutationObserver(() => init());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();